// extracted by mini-css-extract-plugin
export default {"container":"mXSjF2","title":"Ta8tmE"};